import React from 'react';
import PropTypes from 'prop-types';

import messages from './messages';

import Item from './item';
import Arrow from '-!svg-react-loader!./assets/img/arrow.svg?name=Arrow';

const list = (props) => {
  const { items, showButton, showAll, onShowClick, itemCallback } = props;


  return (
    <>
      <ul className="items">
        {
          items.map((item, key) =>
            <Item key={key}
                  text={item.description}
                  price={item.price}
                  code={item.code}
                  callback={itemCallback}/>,
          )
        }
      </ul>
      <div
        className={'show-more'}
        onClick={() => onShowClick()}
      >
        {
          showButton && !showAll &&
          <span> {messages.show.defaultMessage} <Arrow/> </span>
        }
        {
          showButton && showAll &&
          <span className={'active'}> {messages.hide.defaultMessage} <Arrow/> </span>
        }
      </div>
    </>
  );
};


list.defaultProps = {
  showAll: false,
  showButton: false,
  onShowClick: () => {},
  itemCallback: () => {},
};

list.propTypes = {
  showAll: PropTypes.bool,
  onShowClick: PropTypes.func,
  itemCallback: PropTypes.func,
  showButton: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    price: PropTypes.number.isRequired,
    code: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    short_description: PropTypes.string,
    standard_description: PropTypes.string,
  })).isRequired,
};

export default list;
